define(['lodash', 'textCommon', 'componentsCore'], function (_, textCommon, componentsCore) {
    'use strict';

    function getCssStateFromProps(props) {
        // TODO: shouldn't keep $erase in state
        return {
            '$erase': props.compData.value ? 'showButton' : 'hideButton'
        };
    }

    /**
     * @class components.ErasableTextInput
     * @extends {components.BaseTextInput}
     */
    const erasableTextInput = {
        displayName: 'ErasableTextInput',
        mixins: [textCommon.baseTextInput],
        behaviors: textCommon.baseTextInput.BASE_TEXT_BEHAVIORS,

        getInitialState() {
            return getCssStateFromProps(this.props);
        },

        componentWillReceiveProps(nextProps) {
            this.setState(getCssStateFromProps(nextProps));
        },

        getSkinProperties() {
            return _.merge(this.getBaseTextInputSkinProperties(), {
                erase: {
                    children: 'x',
                    onClick: this.props.onErase
                }
            });
        }
    };

    componentsCore.compRegistrar.register('wysiwyg.viewer.components.inputs.ErasableTextInput', erasableTextInput);

    return erasableTextInput;
});
